/**
 * EventForm
 */
import React from 'react';
import { Modal, Grid, Header } from 'semantic-ui-react';
import { FiCheckCircle } from 'react-icons/fi';

// Components
import CreateBinLabelsButton from './components/CreateBinLabelsButton';
import ReturnToSchedulerButton from './components/ReturnToSchedulerButton';

interface Props {
    title: string;
}

class SeasonalEventModalContentSuccess extends React.PureComponent<Props> {
    render() {
        const { title } = this.props;

        return (
            <Modal.Content>
                <Grid>
                    <Grid.Column width={16} textAlign="center">
                        <FiCheckCircle size={85} className="text green" />
                    </Grid.Column>
                    <Grid.Column width={16} textAlign="center">
                        <Header as="h2">{title}</Header>
                    </Grid.Column>
                    <Grid.Column width={16}>
                        <CreateBinLabelsButton />
                    </Grid.Column>
                    <Grid.Column width={16}>
                        <ReturnToSchedulerButton />
                    </Grid.Column>
                </Grid>
            </Modal.Content>
        );
    }
}

export default SeasonalEventModalContentSuccess;
